import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import { avecLibelleTraduit } from '../../i18n/libelles';
import Layout, { LayoutEmbedContext } from '../../components/Layout';
// Les deux onglets partagent GED_READ : pas de filtrage par onglet a faire ici,
// contrairement au hub Courriers ou les trois habilitations different.

import GED from './GED';
import GedDossiers from './GedDossiers';

/**
 * Page-hub de la GED.
 *
 * « Gestion docs GED » (le dépôt) et « Dossiers GED » (l'arborescence) occupaient
 * deux entrées de menu pour un seul domaine. On dépose un document puis on va
 * vérifier où il a atterri : c'est un aller-retour, pas deux destinations.
 *
 * Les deux routes sont conservées et mènent ici, l'onglet se déduisant du chemin -
 * les liens existants et les entrées de menu du backend continuent de fonctionner.
 */

const ONGLETS = avecLibelleTraduit([
  { key: 'depot', path: '/ged', Composant: GED },
  { key: 'dossiers', path: '/ged/dossiers', Composant: GedDossiers },
], 'ged:onglets', { cle: 'key' });

const ongletDuChemin = (pathname) =>
  [...ONGLETS].sort((a, b) => b.path.length - a.path.length)
    .find((o) => pathname.startsWith(o.path))?.key ?? ONGLETS[0].key;

export default function GedLayout() {
  const { t } = useTranslation('ged');
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const actif = ongletDuChemin(pathname);

  return (
    <Layout title={t('titre')}>
      <Tabs
        activeKey={actif}
        onChange={(cle) => {
          const o = ONGLETS.find((x) => x.key === cle);
          if (o) navigate(o.path);
        }}
        items={ONGLETS.map((o) => ({
          key: o.key,
          label: o.label,
          children: actif === o.key ? (
            <LayoutEmbedContext.Provider value={true}>
              <o.Composant />
            </LayoutEmbedContext.Provider>
          ) : null,
        }))}
      />
    </Layout>
  );
}
